var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#A8117D;}\n"),React.createElement("polygon",{"className":"st0","points":"11.5,8.6 8.4,11.1 8.8,11.6 13,8.2 8.8,4.8 8.4,5.3 11.5,7.9 3.4,7.9 3.4,8.6 ","key":1}),React.createElement("g",{"key":2},React.createElement("g",null,React.createElement("path",{"className":"st0","d":"M8.2,0.8c4.1,0,7.5,3.4,7.5,7.5s-3.4,7.5-7.5,7.5s-7.5-3.4-7.5-7.5S4.1,0.8,8.2,0.8 M8.2,0C3.7,0,0,3.7,0,8.2\n\t\t\ts3.7,8.2,8.2,8.2s8.2-3.7,8.2-8.2S12.8,0,8.2,0L8.2,0z"})))]);
}

ArrowRight.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16.4 16.4","style":{"enableBackground":"new 0 0 16.4 16.4"},"xmlSpace":"preserve"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
